/* Theme-Liste (ThemeList.tsx). Zeilenchrom aus dem wirksamen Theme, Vorschau aus dem jeweiligen Theme. */
.mq-theme-list {
  --mq-theme-row-gap: 12px;
  --mq-theme-row-pad: 8px 10px;
  --mq-theme-row-thumb: 112px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mq-theme-row {
  display: flex;
  align-items: center;
  gap: var(--mq-theme-row-gap);
  padding: var(--mq-theme-row-pad);
  border: 1px solid transparent;
  border-radius: var(--mq-theme-radius);
  color: var(--mq-theme-text);
}
.mq-theme-row--interactive { cursor: pointer; }
.mq-theme-row--interactive:hover { background: var(--mq-theme-fill); }
.mq-theme-row--selected { border-color: var(--mq-kit-select); background: var(--mq-theme-surface-2); }
.mq-theme-row:focus-visible { outline: 2px solid var(--mq-theme-primary); outline-offset: 1px; }
.mq-theme-row--disabled { opacity: 0.55; }

.mq-theme-row-preview { flex: 0 0 var(--mq-theme-row-thumb); display: block; }
.mq-theme-row-text { display: flex; flex: 1; align-items: center; gap: 8px; min-width: 0; }
.mq-theme-row-name { flex: 0 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mq-theme-row-badge {
  padding: 0 8px;
  border-radius: 999px;
  background: var(--mq-theme-fill);
  color: var(--mq-theme-text-2);
  font-size: 0.85em;
  white-space: nowrap;
}
.mq-theme-row-trailing { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; justify-content: flex-end; }

/* Auswahl als Kachelraster: Vorschau oben, Name darunter; hell und dunkel einer Familie stehen nebeneinander.
   Immer genau zwei Spalten (Ronny, 20.10.2026): bei breiterem Drawer bzw. kleinerer Anzeigegröße entstanden
   sonst drei Spalten, und die Hell-Dunkel-Paare liefen durcheinander. */
.mq-theme-list--grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.mq-theme-list--grid .mq-theme-row { flex-direction: column; align-items: stretch; gap: 8px; padding: 8px; }
.mq-theme-list--grid .mq-theme-row-preview { flex: none; }
.mq-theme-list--grid .mq-theme-row-text { flex-wrap: wrap; gap: 4px 8px; }

@media (max-width: 575.98px) {
  .mq-theme-list { --mq-theme-row-thumb: 84px; }
  .mq-theme-list:not(.mq-theme-list--grid) .mq-theme-row { flex-wrap: wrap; }
}
